import { render } from "./CreateUnit.vue?vue&type=template&id=59fa6315"
import script from "./CreateUnit.vue?vue&type=script&lang=js"
export * from "./CreateUnit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__